// extracted by mini-css-extract-plugin
var _1 = "logo-module__logo___HH9Jv";
export { _1 as "logo" }
